<ngx-smart-modal #wtCancelModal disableRefocus identifier="wtCancelModal" [customClass]="'wt-cancel-modal'">
    <div class="wt-cancel-title">Cancel Website Texting?</div>
    <div class="wt-cancel-card">
        <div class="wt-cancel-warning-wrapper">
            <div class="wt-cancel-warning">
                <ng-icon [name]="'heroExclamationTriangleSolid'" [size]="'20px'" [color]="'#EA580C'"></ng-icon>
                <div class="wt-cancel-warning-text">
                    <span class="wt-cancel-warning-note">Note</span> - if you cancel, the website widget will automatically stop displaying on your website at the end of the billing period.
                </div>
            </div>
        </div>
        <div class="wt-cancel-form">
            <div class="wt-cancel-reason-section">
                <label class="wt-cancel-reason-label">Why didn't it work for you?</label>
                <div class="wt-cancel-reason-sublabel">We would love to understand why it didn't meet your expectations.</div>
                <rosie-text [type]="'textarea'" [control]="reasonControl"
                    [placeholderTranslationKey]="'Tell us more...'" [rows]="4"></rosie-text>
            </div>
            <div class="wt-cancel-actions">
                <rosie-button (click)="close()" class="d-block" [customClass]="'secondary narrow slim'"
                    [fullWidth]="false" [translationKey]="'Go Back'"></rosie-button>
                <rosie-button (click)="confirmCancel()" class="d-block wt-cancel-confirm-btn"
                    [customClass]="'slim'"
                    [inProgress]="isCancelling" [translationKey]="'Cancel Website Texting'"></rosie-button>
            </div>
        </div>
    </div>
    <div class="wt-cancel-footer">
        Need something more custom? <span class="wt-cancel-contact-link" (click)="contactSupport()">Contact Us</span>
    </div>
</ngx-smart-modal>
<div class="general-intercom-trigger-help rosie-invisible"></div>
